import { render, staticRenderFns } from "./ActiveSwitch.vue?vue&type=template&id=25edec26&"
import script from "./ActiveSwitch.vue?vue&type=script&lang=js&"
export * from "./ActiveSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25edec26')) {
      api.createRecord('25edec26', component.options)
    } else {
      api.reload('25edec26', component.options)
    }
    module.hot.accept("./ActiveSwitch.vue?vue&type=template&id=25edec26&", function () {
      api.rerender('25edec26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/components/ActiveSwitch.vue"
export default component.exports